import React from 'react';
import { createRoot } from 'react-dom/client';
import { TranslateContext } from "../TranslateContext";
import ConfirmPatientMatch from "../../../components/MyDataHelps/ConfirmPatientMatch/ConfirmPatientMatch"
$(document).ready(function () {
	let confirmPatientMatchElement = $(".confirm-patient-match");
	if (!confirmPatientMatchElement.length) { return; }

	let model = JSON.parse(document.getElementById('AntiXssModelInit').textContent);
	let module = angular.module("ConfirmPatientMatch", ['CareEvWidgets', 'ngSanitize', 'ResearchKitApplicationModule', 'ngAria']);

	module.constant('model', model)
	module.constant("availableLocales", model.AvailableLocales)

	module.component('confirmPatientMatch', {
		template: '<div></div>',
		controller: 'ConfirmPatientMatchController'
	});

	module.controller("ConfirmPatientMatchController", ["$element", "$scope", "$translate", "ceUrl", "model",
		function ($element, $scope, $translate, ceUrl, model) {
			const $ctrl = this;
			let props = {
				baseUrl: location.origin + ceUrl.getRoot(),
				model
			};
			
			function renderComponent() {
				$ctrl.root.render(
					<TranslateContext.Provider value={$translate}>
						<ConfirmPatientMatch {...props} />
					</TranslateContext.Provider>
				);
			}

			$ctrl.$onInit = () => {
				$ctrl.root = createRoot($element[0]);
				renderComponent();
				$scope.$watch('$ctrl.props', function () {
					renderComponent();
				}, true);
			}

			$ctrl.$onDestroy = () => $ctrl.root.unmount();
		}
	]);


	module.config(["$translateProvider", "availableLocales", "translateConfigurationProvider",
		function ($translateProvider, availableLocales, translateConfigurationProvider) {
			translateConfigurationProvider.$get().configure($translateProvider, availableLocales);
		}]);
	
	angular.bootstrap(confirmPatientMatchElement, ["ConfirmPatientMatch"]);
});